import React from 'react'

// core components
import withSection from 'components/withSection'
import List from 'components/List/List'
import TwoColumns from 'layouts/TwoColumns'

// icon

const Writings = props => {
  return <TwoColumns icon={['fab', 'dev']} list={<List {...props} />} />
}

export default withSection({ id: 'writings' })(Writings)
